import { useMemo } from "react";
import { CloudArrowDownIcon, FileXIcon } from "@phosphor-icons/react";
import { Progress } from "@heroui/react";

import { PageDataPlaceholder } from "@/shared/components/ui/PageDataPlaceholder";
import { FetchedNote } from "@/services/api/fetchers/notes";
import { useShallow } from "zustand/shallow";
import { useBoundStore } from "@/app/store";
import { usePageLayout } from "@/app/hooks/usePageLayout";

interface NotesInitializationPlaceholderProps {
  notes: FetchedNote[] | null;
}

export function NotesInitializationPlaceholder({ notes }: NotesInitializationPlaceholderProps) {
  const storeInitialized = useBoundStore(useShallow((state) => state.user.storeInitialized));

  const pageLayoutConfig = useMemo(() => ({ navbar: { title: "InkRows", hideBack: true, hideLogo: false } }), []);
  usePageLayout(pageLayoutConfig);

  if (!storeInitialized) {
    return (
      <PageDataPlaceholder
        description="This is a one time process to sync your notes with the server"
        icon={<CloudArrowDownIcon />}
        title="Syncing notes..."
        actions={[<Progress aria-label="Loading..." isIndeterminate key="loading" size="sm" />]}
      />
    );
  }

  if (!notes) {
    return <PageDataPlaceholder title="Notes not found" description="Something went wrong" icon={<FileXIcon />} />;
  }

  return null;
}
